export enum PolicyStateTypeEnum {
    NoError = "NoError",
    PolicyError = "PolicyError"
}
